import { http } from "../../../services/apiCommunicated/Http.interceptor";
import Group from './interfaces/Group';

const URL: string = '/api/v1/grupos';

export const getGroups = () => {
    return http.get<Group[]>(URL);
}

export const getGroupsLocal = () => {
    return http.get<Group[]>(`${URL}/local`);
}

export const getByGroups = (id: string) => {
    return http.get<Group>(`${URL}/${id}`)
}

export const postGroups = (groups: Group) => {
    return http.post<Group>(URL, groups)
}

export const deleteGroups = (id: string) => {
    return http.delete<string>(`${URL}/${id}`)
}

export const putGroups = (groups: Group) => {
    return http.put<Group>(`${URL}`, groups)
}